module.exports = __webpack_public_path__ + "img/product4.35d9062c.png";